import { createAsyncThunk } from '@reduxjs/toolkit';
import { parseErrorData } from 'utils/service';
import { AppAsyncThunkConfig } from 'store/store';
import { NAMESPACE } from './helpers';
import { DrugsByPharmacyItem } from '../models';
import { ServicePharmacies } from 'services/pharmacies';

export const actionDrugsByPharmacyLoadData = createAsyncThunk<
  DrugsByPharmacyItem[],
  void,
  AppAsyncThunkConfig
>(`${NAMESPACE}/loadData`, async () => {
  try {

    const { value } = await ServicePharmacies.getDrugsByPharmacy()

    return value
  } catch (e: any) {
    throw parseErrorData(e);
  }
});
